import React, { useState, useEffect, useRef } from "react";
import "./tableStyle.css";
import {
  getclientslist,
  getAllDoByClient,
  exportDispatchStatusExcel,
  reportsApi,
} from "../../Services/Services";
import { useReactToPrint } from "react-to-print";
import { FaFileExcel, FaPrint } from "react-icons/fa";
import { Col, Button, Form, Select, Input, message } from "antd";
import * as XLSX from "xlsx";
import InfiniteScroll from "react-infinite-scroll-component";
import { debounce } from "../util";

const { Option } = Select;

export default function DispacthStatus() {
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [clientList, setclientList] = useState([]);
  const [doList, setdoList] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(50);
  const [hasMore, setHasMore] = useState(true);
  const [Exporting, setExporting] = useState(false);
  const componentRef = useRef();
  const [form] = Form.useForm();

  const handlePrint = useReactToPrint({ content: () => componentRef.current });

  // Current Year and Years array
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2022 }, (_, i) => 2023 + i);

  useEffect(() => {
    fetchClients();
  }, []);

  // Fetch clients from backend
  const fetchClients = async () => {
    const response = await getclientslist();
    if (response) {
      const filtered = response.client_list.filter(
        (o) => o.com_name === localStorage.getItem("com_name")
      );
      setclientList(filtered);
    }
  };

  // Fetch DO list when client is selected
  const fetchDoList = async (client_id) => {
    if (!client_id) return;
    const response = await getAllDoByClient({
      com_name: localStorage.getItem("com_name"),
      client_id,
    });
    if (response) setdoList(response);
  };

  // Fetch Delivery Orders from backend
  const fetchDeliveryOrders = async (reset = false) => {
    const newOffset = reset ? 0 : offset;
    const response = await reportsApi({
      report_name: "dispatch_status",
      com_name: localStorage.getItem("com_name"),
      client_id: form.getFieldValue("client_id") || null,
      do_id: form.getFieldValue("do_id") || null,
      vehicle_no: form.getFieldValue("vehicle_no") || null,
      year: form.getFieldValue("year") || currentYear,
      offset: newOffset,
      limit,
    });

    const data = response?.results || [];

    if (reset) {
      setDeliveryOrder(data);
      setOffset(limit);
      setHasMore(data.length === limit);
    } else {
      setDeliveryOrder((prev) => [...prev, ...data]);
      setOffset((prev) => prev + limit);
      setHasMore(data.length === limit);
    }
  };

  const handleClientChange = async (clientId) => {
    form.setFieldsValue({ client_id: clientId }); // client set karo aur purana DO clear
    setDeliveryOrder([]); // purana table clear
    setdoList([]); // purana DO list clear
    const doResponse = await getAllDoByClient({
      com_name: localStorage.getItem("com_name"),
      client_id: clientId,
    });
    console.log(doResponse);

    if (doResponse) {
      setdoList(doResponse);
    }
  };

  const handleDoChange = (doId) => {
    form.setFieldsValue({ do_id: doId });
    setDeliveryOrder([]); // purana data clear
    fetchDeliveryOrders(true);
  };

  const debouncedVehicleSearch = useRef(
    debounce((value) => {
      form.setFieldsValue({ vehicle_no: value });
      fetchDeliveryOrders(true);
    }, 400)
  ).current;

  // Export Excel
  const handleExportToExcel = async () => {
    try {
      setExporting(true);
      message.loading({ content: "Generating Excel file...", key: "export" });

      // Prepare parameters
      const params = {
        com_name: localStorage.getItem("com_name"),
        year: form.getFieldValue("year") || currentYear,
        client_id: form.getFieldValue("client_id") || "",
        do_id: form.getFieldValue("do_id") || "",
        vehicle_no: form.getFieldValue("vehicle_no") || "",
        user_type: localStorage.getItem("user_type"),
        lifter_id: localStorage.getItem("user_id"), // Will be used if user_type is Lifter
      };

      // Call the export API
      const response = await exportDispatchStatusExcel(params);

      if (!response.success) {
        throw new Error(response.error || "Failed to export Excel file");
      }

      // Create download link
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;

      // Generate filename with timestamp
      const timestamp = new Date()
        .toISOString()
        .replace(/[:.]/g, "-")
        .slice(0, -5);

      // Extract filename from headers if available
      let filename = `DispatchStatus_${params.year}_${timestamp}.xlsx`;

      const contentDisposition = response.headers?.["content-disposition"];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      }

      link.download = filename;

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success({
        content: "Excel file downloaded successfully!",
        key: "export",
        duration: 2,
      });
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      message.error({
        content:
          error.message || "Failed to export Excel file. Please try again.",
        key: "export",
        duration: 3,
      });
    } finally {
      setExporting(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  return (
    <div>
      <Form layout="vertical" form={form}>
        <div className=" grid grid-cols-1 sm:grid sm:grid-cols-5 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
          <Col>
            <label>
              <b>Select Year</b>
            </label>
            <br />
            <Select
              value={form.getFieldValue("year") || currentYear}
              onChange={(val) => {
                form.setFieldsValue({ year: val });
                fetchDeliveryOrders(true);
              }}
              showSearch
              style={{ width: "95%", margin: "5.5% -3%" }}
              placeholder="Select Year"
            >
              {years.map((y) => (
                <Option key={y} value={y}>
                  {y}
                </Option>
              ))}
            </Select>
          </Col>
          <Form.Item
            name="client_id"
            label={<b>Select Party Name</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Select
              showSearch
              placeholder="Search to Select"
              optionFilterProp="children"
              onChange={handleClientChange}
              style={{ width: "95%", margin: "0 2%" }}
            >
              {clientList.map((c) => (
                <Option key={c.client_id} value={c.client_id}>
                  {c.client_name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="do_id"
            label={<b>Select DO No</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Select
              showSearch
              placeholder="Search to Select"
              optionFilterProp="children"
              onChange={handleDoChange}
              style={{ width: "95%", margin: "0 2%" }}
            >
              {doList.map((d) => (
                <Option key={d.id} value={d.id}>
                  {d.do_no}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="vehicle_no"
            label={<b>Search By Vehicle No</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Input
              placeholder="Enter Vehicle No"
              onChange={(e) => debouncedVehicleSearch(e.target.value)}
              style={{ width: "95%", margin: "0 2%" }}
            />
          </Form.Item>
          <Form.Item>
            <br></br>

            <Button
              onClick={handlePrint}
              style={{
                backgroundColor: "black",
                color: "white",
                marginRight: 10,
              }}
            >
              <FaPrint />
            </Button>
            <Button
              onClick={handleExportToExcel}
              style={{ backgroundColor: "green", color: "white" }}
            >
              <FaFileExcel />
            </Button>
          </Form.Item>
        </div>
      </Form>
      <div
        id="scrollableDiv"
        className="table-wrapper-3"
        style={{ maxHeight: "500px", overflowX: "auto", overflowY: "auto" }}
        ref={componentRef}
      >
        <table id="my-table" className="w-full">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th>Sr. No</th>
              <th>Id</th>
              <th>Truck Owner Name</th>
              <th>Pan No</th>
              <th>Vehicle No</th>
              <th>Dipatch Qty</th>
              <th>Recieved Qty</th>
              <th>Freight Qty</th>
              <th>Sort Qty</th>
              <th>Moisture %</th>
              <th>Actual Qty</th>
              <th>Moisture Deduct Qty</th>
              <th>Moisture Amt</th>
              <th>Moisture Deduct</th>
              <th>Sort Amount</th>
              <th>Freight Rate</th>
              <th>Freight Amt</th>
              <th>Tds %</th>
              <th>Tds Amt</th>
              <th>Advance Amt</th>
              <th>Commision Amt</th>
              <th>Pay Amt</th>
              <th>Dispatch Date</th>
              <th>Received Date</th>
            </tr>
          </thead>
          <tbody>
            {deliveryOrder.map((e, index) => (
              <tr style={{ backgroundColor: e.is_applicable ? "#fbd9d3" : "" }}>
                <td>{index + 1}</td>
                <td>{e.id}</td>
                <td>{e.truck_owner_name}</td>
                <td>{e.pan_no}</td>
                <td>{e.vehicle_no}</td>
                <td>{e.dispatch_quantity.toFixed(3)}</td>
                <td>
                  {e.is_receive ? e.received_quantity.toFixed(3) : "pending"}
                </td>
                <td>
                  {e.is_receive ? e.freight_quantity.toFixed(3) : "pending"}
                </td>
                <td>{e.is_receive ? e.sort_quantity : "pending"}</td>
                <td>{e.is_receive ? e.moisture_received_per : "pending"}</td>
                <td>{e.is_receive ? e.actual_quantity : "pending"}</td>
                <td>{e.is_receive ? e.moisture_deduct_quantity : "pending"}</td>
                <td>{e.is_receive ? e.moisture_amount : "pending"}</td>
                <td>{e.is_receive ? e.moisture_deduct : "pending"}</td>
                <td>{e.is_receive ? e.sort_amount : "pending"}</td>
                <td>{e.freight_rate}</td>
                <td>{e.is_receive ? e.freight_amount : "pending"}</td>
                <td>{e.is_receive ? e.tds_per : "pending"}</td>
                <td>{e.is_receive ? e.tds : "pending"}</td>
                <td>{e.advance}</td>
                <td>{e.is_receive ? e.commision : "pending"}</td>
                <td>{e.is_payment ? e.pay_amount : "pending"}</td>
                <td>{formatDate(e.date)}</td>
                <td>{formatDate(e.received_date)}</td>
              </tr>
            ))}
            <tr style={{ backgroundColor: "#e9e9e9" }}>
              <td
                className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"
                colSpan={5}
              >
                <b>Total</b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.dispatch_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.received_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.freight_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.sort_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.moisture_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.moisture_deduct,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.sort_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.freight_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.tds,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.advance,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.commision,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.pay_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td
                className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"
                colSpan={2}
              ></td>
            </tr>
          </tbody>
        </table>
        <InfiniteScroll
          dataLength={deliveryOrder.length}
          next={() => fetchDeliveryOrders(false)}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
          endMessage={
            <p style={{ textAlign: "center" }}>
              <b>All data loaded</b>
            </p>
          }
          scrollableTarget="scrollableDiv"
        />
      </div>
    </div>
  );
}
